import { PartnerTimeZoneTooltip } from 'src/components';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { useDisplayTime } from 'src/utils/hooks';

export const ActivityFeedTime = ({ activity }: { activity: ActivityFeed }) => {
  const { displayTime } = useDisplayTime();
  const date = activity.timestamp;
  return (
    <PartnerTimeZoneTooltip date={date} partnerId={activity.partnerId}>
      {displayTime(date)}
    </PartnerTimeZoneTooltip>
  );
};
